/* oxlint-disable grafit-oxlint/no-tailwind-font-classes -- Typography 2 migration */
import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { lazy, Suspense } from "react";

const ContentLayoutStories = lazy(() =>
  import("../../../../storybook/content-layout-stories").then((module) => ({
    default: module.ContentLayoutStories,
  })),
);

export const Route = createFileRoute("/_auth/_frame/storybook/content-layout")({
  component: ContentLayoutPage,
});

function ContentLayoutPage() {
  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-2 border-b px-4 py-3">
        <Link to="/storybook" className="flex items-center gap-1 text-neutral-500 text-sm hover:text-neutral-900">
          {/* oxlint-disable-next-line grafit-oxlint/enforce-icon-variants */}
          <ArrowLeftIcon className="h-4 w-4" />
          Back to Storybook
        </Link>
      </div>
      <div className="min-h-0 flex-1">
        <Suspense
          fallback={
            <div className="flex items-center justify-center py-8">
              <div className="flex items-center gap-2 text-neutral-500">
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
                <span className="text-sm">Loading component stories...</span>
              </div>
            </div>
          }
        >
          <ContentLayoutStories />
        </Suspense>
      </div>
    </div>
  );
}
